import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import { FormFeedback } from 'reactstrap';
import './error-message.scss';

type Props = {
  isError: boolean;
  error: ReactNode;
};

export default function ErrorMessage({ isError, error }: Props): ReactElement {
  return (
    <>
      {isError && (
        <FormFeedback className="form-error" tooltip>
          {error}
        </FormFeedback>
      )}
    </>
  );
}
